import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "answer" }
const _hoisted_2 = { class: "answer" }

import {
  Barrier,
  Behavior,
  BPTAnswer,
  Co2ScanInterest,
  ExpertiseLevel,
  Motivation,
  SelfReliance,
  Target,
} from '@/models/bpt.model';
import { PropType, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BPTAnswersField',
  props: {
  modelValue: {
    type: Object as PropType<BPTAnswer[]>,
    required: true,
  },
  questionType: {
    type: String,
    required: true,
  },
},
  emits: ['update:modelValue', 'change'],
  setup(__props, { emit: __emit }) {

const props = __props;

const questionTypeAnswerValueMap: { [index: string]: string[] } = {
  interests: [],
  expertise: [...Object.values(ExpertiseLevel)],
  motivation: [
    ...Object.values(Motivation).filter((v) => v !== Motivation.Unknown),
  ],
  behavior: [...Object.values(Behavior)],
  barrier: [...Object.values(Barrier).filter((v) => v !== Barrier.Unknown)],
  target: [...Object.values(Target).filter((v) => v !== Target.Unknown)],
  'self-reliance': [...Object.values(SelfReliance)],
  'co2-scan': [
    ...Object.values(Co2ScanInterest).filter(
      (v) => v !== Co2ScanInterest.Unknown,
    ),
  ],
  location: [],
};

const answers = ref<BPTAnswer[]>([
  ...(props.modelValue || []).sort((a, b) => a.index - b.index),
]);

const emit = __emit;

function update() {
  emit('update:modelValue', answers.value);
  emit('change');
}

function addAnswer() {
  answers.value.push({
    text: '',
    hint: '',
    value: '',
    index: answers.value.length,
  });
  update();
}

function removeAnswer(index: number) {
  answers.value.splice(index, 1);
  update();
}

function moveUp(answer: BPTAnswer) {
  const index = answers.value.findIndex((a) => a.id === answer.id);

  answers.value = [
    ...answers.value.slice(0, index - 1),
    answer,
    answers.value[index - 1],
    ...answers.value.slice(index + 1),
  ].map((v, index) => ({ ...v, index }));

  update();
}

function moveDown(answer: BPTAnswer) {
  const index = answers.value.findIndex((a) => a.id === answer.id);

  answers.value = [
    ...answers.value.slice(0, index),
    answers.value[index + 1],
    answer,
    ...answers.value.slice(index + 2),
  ].map((v, index) => ({ ...v, index }));

  update();
}

watch(
  () => props.modelValue,
  () => {
    Object.assign(answers.value, props.modelValue);
  },
  { deep: true },
);

return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[6] || (_cache[6] = _createElementVNode("h3", null, "Answers", -1)),
    (
        (__props.questionType !== 'location' &&
          __props.questionType !== 'interests' &&
          answers.value.length !==
            questionTypeAnswerValueMap[__props.questionType]?.length) ||
        0
      )
      ? (_openBlock(), _createBlock(_component_v_alert, {
          key: 0,
          type: "info"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode("Please provide all answer options")
          ])),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_list, null, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(answers.value, (answer, index) => {
          return (_openBlock(), _createBlock(_component_v_list_item, { key: index }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_v_text_field, {
                  modelValue: answer.text,
                  "onUpdate:modelValue": ($event: any) => ((answer.text) = $event),
                  label: "Answer",
                  width: "45%",
                  placeholder: `Answer ${index + 1}`,
                  required: "",
                  onChange: update
                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]),
                _cache[1] || (_cache[1] = _createTextVNode("   ")),
                _createVNode(_component_v_btn, {
                  icon: "mdi-arrow-up",
                  class: "remove-button",
                  density: "compact",
                  disabled: index === 0 || answer.id === undefined,
                  onClick: _withModifiers(($event: any) => (moveUp(answer)), ["prevent"])
                }, null, 8, ["disabled", "onClick"]),
                _cache[2] || (_cache[2] = _createTextVNode("   ")),
                _createVNode(_component_v_btn, {
                  icon: "mdi-arrow-down",
                  class: "remove-button",
                  density: "compact",
                  disabled: index === answers.value.length - 1 || answer.id === undefined,
                  onClick: _withModifiers(($event: any) => (moveDown(answer)), ["prevent"])
                }, null, 8, ["disabled", "onClick"]),
                _cache[3] || (_cache[3] = _createTextVNode("   ")),
                _createVNode(_component_v_btn, {
                  icon: "mdi-delete-outline",
                  class: "remove-button",
                  density: "compact",
                  onClick: _withModifiers(($event: any) => (removeAnswer(index)), ["prevent"])
                }, null, 8, ["onClick"])
              ]),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_v_text_field, {
                  width: "60%",
                  modelValue: answer.hint,
                  "onUpdate:modelValue": ($event: any) => ((answer.hint) = $event),
                  label: "Hint",
                  onChange: update
                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                _cache[4] || (_cache[4] = _createTextVNode("   ")),
                _createVNode(_component_v_select, {
                  width: "40%",
                  modelValue: answer.value,
                  "onUpdate:modelValue": ($event: any) => ((answer.value) = $event),
                  label: "Value",
                  onChange: update,
                  items: questionTypeAnswerValueMap[__props.questionType]
                }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
              ])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_component_v_btn, {
      onClick: addAnswer,
      color: "success"
    }, {
      default: _withCtx(() => _cache[5] || (_cache[5] = [
        _createTextVNode("Add answer")
      ])),
      _: 1
    })
  ]))
}
}

})